// extracted by mini-css-extract-plugin
export default {"wrapper":"ap","form":"bp","required":"cp","label":"dp","small":"ep","noMargin":"fp","success":"gp","circle":"hp","successText":"ip","appointment":"jp"};